export enum ConsolidationMethod {
  Average = 1,
  Sum = 2,
  Last = 3,
}
